import {
    AppointmentList,
    Appoint,
    SearchList,
    AppointMain,
    EmpAppoint,
    StoreAppoint,
    NewAppointMain,
    CancelAppoint
} from '../pages/appointment';

const indexChooseShop = resolve => require.ensure([], () => resolve(require('@/pages/subscribe/indexChooseShop.vue')), 'indexChooseShop')
export default [
    /**我的预约记录  更换组件 */
    {
        path: '/AppointmentList',
        name: 'AppointmentList',
        component: indexChooseShop,
        meta: {
            title: '我的预约',
            keepAlive: true

        }
    }, {
        path: '/Appoint',
        name: 'Appoint',
        component: Appoint,
        meta: {
            title: '预约'
        }
    },
    {
        path: '/SearchList',
        name: 'SearchList',
        component: SearchList,
        meta: {
            title: '搜索'
        }
    },
    {
        path: '/AppointMain',
        name: 'AppointMain',
        component: AppointMain,
        meta: {
            title: '预约'
        }
    },
    {
        path: '/EmpAppoint',
        name: 'EmpAppoint',
        component: EmpAppoint,
        meta: {
            title: '预约'
        }
    },
    {
        path: '/StoreAppoint',
        name: 'StoreAppoint',
        component: StoreAppoint,
        meta: {
            title: '预约'
        }
    },
    {
        path: '/NewAppointMain',
        name: 'NewAppointMain',
        component: NewAppointMain,
        meta: {
            title: '预约'
        }
    },
    {
        path: '/CancelAppoint',
        name: 'CancelAppoint',
        component: CancelAppoint,
        meta: {
            title: '取消预约'
        }
    }
   
]



// WEBPACK FOOTER //
// ./src/router/appoint-router.js